import { render } from "./PriceFormula.vue?vue&type=template&id=a489ce8c"
import script from "./PriceFormula.vue?vue&type=script&lang=js"
export * from "./PriceFormula.vue?vue&type=script&lang=js"

import "./PriceFormula.vue?vue&type=style&index=0&id=a489ce8c&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__